import { createTheme, ITheme } from '@uifabric/styling';

export const FluentTheme: ITheme = createTheme({});

export default FluentTheme;
